export default __webpack_public_path__ + "static/media/Jam-Matkul-dark.d37dd5d8.svg";